// extracted by mini-css-extract-plugin
export default {"shoppingSummaryText":"OrderOverview_shoppingSummaryText__ZQlDQ"};